import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const RewardsActivityDetails = ({ onNext = () => {}, onBack = () => {}, inputs, canGoNext }) => {
  const { t } = useTranslation(['rewards-loyalty', 'common'])
  return (
    <div>
      <div className="rewards-modal-content rewards-base-view activity-details">
        {inputs.first && inputs.first.isVisible && (
          <div className="rewards-modal-input-row">
            <div className="input-container">
              <div className="input-label disabled">{inputs.first.label}</div>
              {inputs.first.render()}
            </div>
          </div>
        )}
        <div className="rewards-modal-input-row">
          {inputs.second && (
            <div className="input-container">
              <div className={`input-label ${inputs.second.disabled ? 'disabled' : ''}`}>
                {inputs.second.label}
              </div>
              {inputs.second.render()}
            </div>
          )}
        </div>
        <div className="rewards-modal-input-row">
          {inputs.third && (
            <div className="input-container">
              <div className={`input-label ${inputs.third.disabled ? 'disabled' : ''}`}>
                {inputs.third.label}
              </div>
              {inputs.third.render()}
            </div>
          )}
        </div>
      </div>
      <div className="rewards-modal-actions">
        <button className="button button-gray" onClick={onBack}>
          {t('common:actions.back')}
        </button>
        <button className="button button-primary auto-width" disabled={!canGoNext} onClick={onNext}>
          {t('rewards-loyalty:activityForm.nextButton')}
        </button>
      </div>
    </div>
  )
}

RewardsActivityDetails.propTypes = {
  onNext: PropTypes.func,
  onBack: PropTypes.func,
  inputs: PropTypes.object,
  canGoNext: PropTypes.bool,
}

export default RewardsActivityDetails
